import styled from 'styled-components';

export const EventTitle = styled.p`
  width: 100%;
  display: block;
  font-size: 16px;
  letter-spacing: -0.4px;
  color: #4d5057;
  margin-bottom: 0;
  line-height: 1.2em;
`;
